<template>
  <div class="school-navigation">
    <v-navigation-drawer width="100%" permanent>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title"> منو کاربری </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          router
          :to="{ name: item.router, query: {} }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  name: "navigation-component",
  data: () => {
    return {
      items: [
        {
          title: "درخواست جدید",
          icon: "mdi-book-open-page-variant-outline",
          router: "AgentActiveSchools"
        },
        {
          title: "مدارس تایید شده",
          icon: "mdi-card-account-details-outline",
          router: "AgentActivedSchools"
        },
        {
          title: "پرداخت ها",
          icon: "mdi-card-account-details-outline",
          router: "AgentPeyments"
        }
      ]
    };
  }
};
</script>
